module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0002.jpg?v=39aad497";